export interface Basemap {
  id: string;
  label: string;
  /** Style URL — what `useUiStore.basemap` persists. */
  url: string;
  /**
   * Photographic imagery rather than a flat vector style. Overlays drawn
   * straight onto the map with no surface of their own (e.g. the OI timeline
   * scrubber, ENG-208) switch to a higher-contrast palette over these.
   */
  imagery?: boolean;
}

export const BASEMAPS: Basemap[] = [
  {
    id: 'light',
    label: 'Light',
    url: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
  },
  {
    id: 'voyager',
    label: 'Voyager',
    url: 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json',
  },
  {
    id: 'satellite',
    label: 'Satellite',
    url: 'mapbox://styles/mapbox/satellite-streets-v12',
    imagery: true,
  },
  {
    id: 'dark',
    label: 'Dark',
    url: 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json',
  },
];

/** Whether the given style URL (as stored in `useUiStore.basemap`) is imagery. */
export function isImageryBasemap(url: string): boolean {
  return BASEMAPS.some((b) => b.url === url && b.imagery);
}
